/**
 * D4F PREMIUM HEADER
 * - Sticky Header mit Scroll-Effekt
 * - Mega-Menü Handling
 * - Mobile Menu mit Accordion
 * - Search Overlay mit Scroll
 * - Cart Count Update
 * - Recently Viewed mit Progress Bar (EXAKT WIE PRODUCT HERO)
 */
(function () {
  const header = document.querySelector('.d4f-header');
  if (!header) return;

  // Elements
  const menuToggle = document.querySelector('.d4f-header__menu-toggle');
  const mobileMenu = document.querySelector('.d4f-mobile-menu');
  const mobileMenuClose = document.querySelector('.d4f-mobile-menu__close');
  const searchToggle = document.querySelector('.d4f-header__action--search');
  const searchOverlay = document.querySelector('.d4f-search-overlay');
  const searchClose = document.querySelector('.d4f-search-overlay__close');
  const recentToggle = document.querySelector('.d4f-header__action--recent');
  const recentModal = document.querySelector('.d4f-recent-modal');
  const recentClose = document.querySelector('.d4f-recent-modal__close');
  const backdrop = document.querySelector('.d4f-header-backdrop');
  const cartCount = document.querySelector('.d4f-header__cart-count');

  // Initialize
  initStickyHeader();
  initMobileMenu();
  initSearchOverlay();
  initRecentlyViewed();
  initMobileAccordion();
  initCartCount();
  initKeyboardShortcuts();

  /**
   * STICKY HEADER WITH SCROLL EFFECT
   */
  function initStickyHeader() {
    let lastScrollTop = 0;
    let ticking = false;

    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    });

    function handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > 50) {
        header.classList.add('is-scrolled');
        document.body.classList.add('header-scrolled');
      } else {
        header.classList.remove('is-scrolled');
        document.body.classList.remove('header-scrolled');
      }

      lastScrollTop = scrollTop;
    }
  }

  /**
   * MOBILE MENU
   */
  function initMobileMenu() {
    if (!menuToggle || !mobileMenu) return;

    menuToggle.addEventListener('click', () => {
      openMobileMenu();
    });

    if (mobileMenuClose) {
      mobileMenuClose.addEventListener('click', () => {
        closeMobileMenu();
      });
    }

    if (backdrop) {
      backdrop.addEventListener('click', () => {
        closeMobileMenu();
      });
    }

    const mobileLinks = mobileMenu.querySelectorAll('.d4f-mobile-menu__sublink, .d4f-mobile-menu__link:not(.d4f-mobile-menu__toggle)');
    mobileLinks.forEach(link => {
      link.addEventListener('click', () => {
        closeMobileMenu();
      });
    });

    console.log('[D4F Mobile Menu] Initialized');
  }

  function openMobileMenu() {
    mobileMenu.classList.add('is-active');
    menuToggle.classList.add('is-active');
    backdrop.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    
    const mainContent = document.querySelector('#MainContent, main, .main-content');
    if (mainContent) {
      mainContent.style.position = 'relative';
      mainContent.style.zIndex = '1';
    }
  }

  function closeMobileMenu() {
    mobileMenu.classList.remove('is-active');
    menuToggle.classList.remove('is-active');
    backdrop.classList.remove('is-active');
    document.body.style.overflow = '';
    
    const mainContent = document.querySelector('#MainContent, main, .main-content');
    if (mainContent) {
      mainContent.style.position = '';
      mainContent.style.zIndex = '';
    }
  }

  /**
   * MOBILE ACCORDION
   */
  function initMobileAccordion() {
    const toggles = document.querySelectorAll('.d4f-mobile-menu__toggle');

    toggles.forEach(toggle => {
      toggle.addEventListener('click', () => {
        const parent = toggle.closest('.d4f-mobile-menu__item');
        const isActive = parent.classList.contains('is-active');

        document.querySelectorAll('.d4f-mobile-menu__item.is-active').forEach(item => {
          if (item !== parent) {
            item.classList.remove('is-active');
          }
        });

        if (isActive) {
          parent.classList.remove('is-active');
        } else {
          parent.classList.add('is-active');
        }
      });
    });
  }

  /**
   * SEARCH OVERLAY
   */
  function initSearchOverlay() {
    if (!searchToggle || !searchOverlay) return;

    searchToggle.addEventListener('click', () => {
      openSearchOverlay();
    });

    if (searchClose) {
      searchClose.addEventListener('click', () => {
        closeSearchOverlay();
      });
    }

    searchOverlay.addEventListener('click', (e) => {
      if (e.target === searchOverlay) {
        closeSearchOverlay();
      }
    });

    const searchInput = searchOverlay.querySelector('.d4f-search-form__input');
    searchOverlay.addEventListener('transitionend', () => {
      if (searchOverlay.classList.contains('is-active') && searchInput) {
        searchInput.focus();
      }
    });

    if (searchInput) {
      let debounceTimer;
      searchInput.addEventListener('input', (e) => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          performSearch(e.target.value);
        }, 300);
      });
    }
  }

  function openSearchOverlay() {
    searchOverlay.classList.add('is-active');
    document.body.classList.add('search-active');
    document.body.style.overflow = 'hidden';
  }

  function closeSearchOverlay() {
    searchOverlay.classList.remove('is-active');
    document.body.classList.remove('search-active');
    document.body.style.overflow = '';
  }

  function performSearch(query) {
    if (!query || query.length < 2) {
      clearSearchResults();
      return;
    }

    const resultsContainer = document.querySelector('.d4f-search-results');
    if (!resultsContainer) return;

    resultsContainer.innerHTML = `
      <div class="d4f-search-loading">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="animation: spin 1s linear infinite;">
          <circle cx="12" cy="12" r="10" opacity="0.25"/>
          <path d="M12 2a10 10 0 0 1 10 10" opacity="0.75"/>
        </svg>
        <div style="margin-top: 16px;">Suche läuft...</div>
      </div>
      <style>
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      </style>
    `;

    fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8`)
      .then(response => response.json())
      .then(data => {
        displaySearchResults(data, query);
      })
      .catch(error => {
        console.error('Search error:', error);
        resultsContainer.innerHTML = '<div class="d4f-search-error">Suche fehlgeschlagen. Bitte versuche es erneut.</div>';
      });
  }

  function displaySearchResults(data, query) {
    const resultsContainer = document.querySelector('.d4f-search-results');
    if (!resultsContainer) return;

    if (!data.resources || !data.resources.results || !data.resources.results.products || data.resources.results.products.length === 0) {
      resultsContainer.innerHTML = `
        <div class="d4f-search-empty">
          Keine Produkte gefunden.
          <a href="/search?q=${encodeURIComponent(query)}" class="d4f-search-view-all">
            Alle Produkte durchsuchen
          </a>
        </div>
      `;
      return;
    }

    const products = data.resources.results.products;
    
    let html = '<div class="d4f-search-products">';
    
    products.forEach(product => {
      let price = '';
      let comparePrice = '';
      
      if (typeof product.price === 'number') {
        price = (product.price / 100).toFixed(2).replace('.', ',');
      } else if (typeof product.price === 'string') {
        price = product.price;
      }
      
      if (product.compare_at_price_max && product.compare_at_price_max > product.price) {
        if (typeof product.compare_at_price_max === 'number') {
          comparePrice = (product.compare_at_price_max / 100).toFixed(2).replace('.', ',');
        } else {
          comparePrice = product.compare_at_price_max;
        }
      }
      
      html += `
        <a href="${product.url}" class="d4f-search-product">
          <div class="d4f-search-product__image">
            ${product.image ? `<img src="${product.image}" alt="${product.title}" loading="lazy">` : '<div class="d4f-search-product__no-image">Kein Bild</div>'}
          </div>
          <div class="d4f-search-product__info">
            <h4 class="d4f-search-product__title">${product.title}</h4>
            <div class="d4f-search-product__price">
              ${comparePrice ? `<span class="d4f-search-product__compare-price">${comparePrice} €</span>` : ''}
              <span class="d4f-search-product__current-price">${price} €</span>
            </div>
          </div>
        </a>
      `;
    });
    
    html += '</div>';
    html += `
      <div class="d4f-search-footer">
        <a href="/search?q=${encodeURIComponent(query)}" class="d4f-search-view-all">
          Alle Produkte durchsuchen
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M5 12h14M12 5l7 7-7 7"/>
          </svg>
        </a>
      </div>
    `;
    
    resultsContainer.innerHTML = html;

    if (!document.getElementById('d4f-search-results-style')) {
      const style = document.createElement('style');
      style.id = 'd4f-search-results-style';
      style.textContent = `
        .d4f-search-loading,
        .d4f-search-error {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
          padding: 80px 20px;
          color: #a89a86;
          font-size: 16px;
          min-height: 300px;
        }
        
        .d4f-search-empty {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
          padding: 80px 20px;
          color: #a89a86;
          font-size: 16px;
          gap: 20px;
          min-height: 300px;
        }
        
        .d4f-search-products {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
          gap: 20px;
          margin-bottom: 32px;
        }
        
        .d4f-search-product {
          display: flex;
          flex-direction: column;
          gap: 12px;
          padding: 16px;
          background: rgba(20, 16, 13, 0.6);
          border: 1px solid rgba(212, 165, 116, 0.2);
          border-radius: 12px;
          text-decoration: none;
          transition: all 0.3s ease;
        }
        
        .d4f-search-product:hover {
          background: rgba(20, 16, 13, 0.8);
          border-color: rgba(212, 165, 116, 0.4);
          transform: translateY(-2px);
        }
        
        .d4f-search-product__image {
          width: 100%;
          height: 220px;
          border-radius: 8px;
          overflow: hidden;
          background: rgba(0, 0, 0, 0.3);
        }
        
        .d4f-search-product__image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        
        .d4f-search-product__no-image {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #a89a86;
          font-size: 14px;
        }
        
        .d4f-search-product__title {
          font-size: 15px;
          font-weight: 600;
          color: #f5f0e8;
          margin: 0;
          line-height: 1.3;
        }
        
        .d4f-search-product__price {
          display: flex;
          align-items: center;
          gap: 8px;
        }
        
        .d4f-search-product__current-price {
          font-size: 16px;
          font-weight: 700;
          color: #d4a574;
        }
        
        .d4f-search-product__compare-price {
          font-size: 14px;
          color: #a89a86;
          text-decoration: line-through;
        }
        
        .d4f-search-footer {
          display: flex;
          justify-content: center;
          padding-top: 24px;
          margin-top: 24px;
          border-top: 1px solid rgba(212, 165, 116, 0.1);
        }
        
        .d4f-search-view-all {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          padding: 16px 36px;
          background: linear-gradient(135deg, #d4a574, #c9995e);
          color: #1a1410;
          text-decoration: none;
          border-radius: 12px;
          font-size: 15px;
          font-weight: 700;
          transition: all 0.3s ease;
          box-shadow: 0 4px 12px rgba(212, 165, 116, 0.3);
        }
        
        .d4f-search-view-all:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 24px rgba(212, 165, 116, 0.5);
        }
        
        @media (max-width: 640px) {
          .d4f-search-products {
            grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
            gap: 16px;
            margin-bottom: 24px;
          }
          
          .d4f-search-product {
            padding: 12px;
          }
          
          .d4f-search-product__image {
            height: 160px;
          }
          
          .d4f-search-view-all {
            padding: 14px 28px;
            font-size: 14px;
          }
        }
      `;
      document.head.appendChild(style);
    }
  }

  function clearSearchResults() {
    const resultsContainer = document.querySelector('.d4f-search-results');
    if (resultsContainer) {
      resultsContainer.innerHTML = '';
    }
  }

  /**
   * CART COUNT UPDATE
   */
  function initCartCount() {
    if (!cartCount) return;

    updateCartCount();

    document.addEventListener('cart:updated', () => {
      updateCartCount();
    });

    if (window.Shopify && window.Shopify.theme) {
      document.addEventListener('shopify:section:load', () => {
        updateCartCount();
      });
    }
  }

  async function updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const count = cart.item_count || 0;

      console.log('[D4F Header] 🛒 Cart count:', count);

      if (cartCount) {
        cartCount.textContent = count;
        cartCount.style.display = count > 0 ? 'flex' : 'none';
      }

      if (count > 0 && cartCount) {
        cartCount.style.transform = 'scale(1.2)';
        setTimeout(() => {
          cartCount.style.transform = 'scale(1)';
        }, 200);
      }

      await updateProgressBar();
      
    } catch (error) {
      console.error('[D4F Header] Error updating cart count:', error);
    }
  }

  /**
   * RECENTLY VIEWED MODAL
   */
  function initRecentlyViewed() {
    if (!recentToggle || !recentModal) return;

    recentToggle.addEventListener('click', () => {
      openRecentModal();
    });

    if (recentClose) {
      recentClose.addEventListener('click', () => {
        closeRecentModal();
      });
    }

    recentModal.addEventListener('click', (e) => {
      if (e.target === recentModal) {
        closeRecentModal();
      }
    });

    trackProductView();

    recentToggle.addEventListener('click', () => {
      updateRecentProducts();
      updateProgressBar();
    });

    // Initial update
    setTimeout(() => {
      updateProgressBar();
    }, 1000);

    // Update on cart events
    document.addEventListener('cart:updated', () => {
      console.log('[D4F Header] ⚡ Cart updated - updating progress bar');
      updateProgressBar();
    });

    document.addEventListener('cart:item-added', () => {
      console.log('[D4F Header] ⚡ Item added - updating progress bar');
      setTimeout(() => updateProgressBar(), 500);
    });

    if (window.Shopify && window.Shopify.theme) {
      document.addEventListener('shopify:section:load', () => {
        updateProgressBar();
      });
    }

    // Fallback polling when modal is open
    setInterval(() => {
      if (recentModal && recentModal.classList.contains('is-active')) {
        updateProgressBar();
      }
    }, 2000);
  }

  function openRecentModal() {
    recentModal.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    updateProgressBar();
  }

  function closeRecentModal() {
    recentModal.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  function trackProductView() {
    if (!window.location.pathname.includes('/products/')) return;

    const productHandle = window.location.pathname.split('/products/')[1]?.split('?')[0];
    if (!productHandle) return;

    const productData = {
      handle: productHandle,
      title: document.querySelector('.d4f-product-hero__title, .product-title, h1')?.textContent?.trim() || 'Produkt',
      price: document.querySelector('.d4f-app-block .tee-price--current, .product-price, .price')?.textContent?.trim() || '',
      image: document.querySelector('.product__media-item img, .product-image img')?.src || '',
      url: window.location.pathname,
      timestamp: Date.now()
    };

    let recentProducts = JSON.parse(localStorage.getItem('d4f_recent_products') || '[]');
    recentProducts = recentProducts.filter(p => p.handle !== productHandle);
    recentProducts.unshift(productData);
    recentProducts = recentProducts.slice(0, 6);
    localStorage.setItem('d4f_recent_products', JSON.stringify(recentProducts));
  }

  function updateRecentProducts() {
    const container = document.querySelector('[data-recent-products]');
    if (!container) return;

    const recentProducts = JSON.parse(localStorage.getItem('d4f_recent_products') || '[]');

    if (recentProducts.length === 0) {
      container.innerHTML = `
        <div class="d4f-recent-empty">
          <div class="d4f-recent-empty__icon">👀</div>
          <div class="d4f-recent-empty__text">
            Du hast noch keine Produkte angesehen.<br>
            Stöbere durch unseren Shop und finde dein perfektes Geschenk!
          </div>
        </div>
      `;
      return;
    }

    let html = '';
    recentProducts.forEach(product => {
      html += `
        <a href="${product.url}" class="d4f-recent-product">
          <div class="d4f-recent-product__image">
            ${product.image ? `<img src="${product.image}" alt="${product.title}" loading="lazy">` : ''}
          </div>
          <div class="d4f-recent-product__info">
            <h4 class="d4f-recent-product__title">${product.title}</h4>
            <div class="d4f-recent-product__price">${product.price}</div>
          </div>
        </a>
      `;
    });

    container.innerHTML = html;
  }

  /**
   * PROGRESS BAR UPDATE - EXAKT WIE PRODUCT HERO
   * Rabattstufen (KORREKT):
   * - 2 Produkte = 10%
   * - 3 Produkte = 15%
   * - 4 Produkte = 20%
   * - 5+ Produkte = 25% (Maximum)
   * 
   * Progress Bar Logik:
   * - Zeigt immer Fortschritt zur NÄCHSTEN Stufe
   * - 1 Produkt: 50% gefüllt (1 von 2)
   * - 2 Produkte: 50% gefüllt (2 von 3) 
   * - 3 Produkte: 50% gefüllt (3 von 4)
   * - 4 Produkte: 50% gefüllt (4 von 5)
   * - 5+ Produkte: 100% gefüllt (Maximum)
   */
  async function updateProgressBar() {
    console.log('[D4F Header] 🔄 Updating progress bar...');
    
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      const itemCount = cart.item_count || 0;
      console.log('[D4F Header] 📊 Items in cart:', itemCount);

      const progressFill = document.querySelector('.d4f-progress-bar__fill');
      const progressText = document.querySelector('.d4f-progress-widget__text');
      const remainingElement = document.querySelector('[data-remaining]');

      if (!progressFill || !progressText) {
        console.warn('[D4F Header] ⚠️ Progress elements not found');
        return;
      }

      let progress = 0;
      let currentCount = itemCount;
      let nextThreshold = 0;
      let currentDiscount = '';
      let nextDiscount = '';

      if (itemCount === 0) {
        progress = 0;
        currentCount = 0;
        nextThreshold = 2;
        nextDiscount = '10%';
      } else if (itemCount === 1) {
        progress = 50; // 1 von 2
        currentCount = 1;
        nextThreshold = 2;
        nextDiscount = '10%';
      } else if (itemCount === 2) {
        progress = 50; // 2 von 3
        currentCount = 2;
        nextThreshold = 3;
        currentDiscount = '10%';
        nextDiscount = '15%';
      } else if (itemCount === 3) {
        progress = 50; // 3 von 4
        currentCount = 3;
        nextThreshold = 4;
        currentDiscount = '15%';
        nextDiscount = '20%';
      } else if (itemCount === 4) {
        progress = 50; // 4 von 5
        currentCount = 4;
        nextThreshold = 5;
        currentDiscount = '20%';
        nextDiscount = '25%';
      } else { // 5+
        progress = 100; // Maximum erreicht
        currentCount = itemCount;
        nextThreshold = 5;
        currentDiscount = '25%';
      }

      // Progress Bar füllen (GOLD/GELB) - ULTRA-AGGRESSIVE!
      progressFill.style.width = `${progress}%`;
      progressFill.style.setProperty('background', 'linear-gradient(90deg, #d4a574 0%, #e0b280 100%)', 'important');
      progressFill.style.setProperty('background-color', '#d4a574', 'important');
      progressFill.style.setProperty('background-image', 'linear-gradient(90deg, #d4a574 0%, #e0b280 100%)', 'important');
      progressFill.style.setProperty('box-shadow', '0 0 12px rgba(212, 165, 116, 0.6), 0 0 20px rgba(212, 165, 116, 0.4)', 'important');
      
      progressFill.setAttribute('data-color', 'gold');
      
      console.log('[D4F Header] ✅ Progress bar filled to:', progress + '%');
      console.log('[D4F Header] 🎨 Progress bar color set to GOLD (#d4a574)');
      console.log('[D4F Header] 🎨 Computed background:', window.getComputedStyle(progressFill).background);
      console.log(`[D4F Header] 📍 Showing: ${currentCount} links, ${nextThreshold} rechts`);

      // Text aktualisieren
      if (itemCount >= 5) {
        progressText.innerHTML = `
          🎉 <strong>Glückwunsch!</strong> Du hast die höchste Rabattstufe erreicht: <strong>25% Rabatt</strong>
        `;
        
        if (remainingElement) {
          remainingElement.textContent = `${currentCount} Produkte`;
        }
        
        console.log('[D4F Header] ✅ Maximum reached (25%)');
      } else if (itemCount >= 2) {
        const remaining = nextThreshold - currentCount;
        const productText = remaining === 1 ? 'Produkt' : 'Produkte';
        
        progressText.innerHTML = `
          🎉 <strong>${currentDiscount} Rabatt</strong> erreicht! Noch <span class="d4f-progress-widget__amount">${remaining} ${productText}</span> bis zu <strong>${nextDiscount} Rabatt</strong>
        `;
        
        if (remainingElement) {
          remainingElement.textContent = `${remaining} ${productText}`;
        }
        
        console.log(`[D4F Header] ✅ ${currentCount} Produkte - ${currentDiscount} erreicht, noch ${remaining} bis ${nextDiscount}`);
      } else {
        const remaining = nextThreshold - currentCount;
        const productText = remaining === 1 ? 'Produkt' : 'Produkte';
        
        progressText.innerHTML = `
          Noch <span class="d4f-progress-widget__amount">${remaining} ${productText}</span> bis zu <strong>${nextDiscount} Rabatt</strong>
        `;
        
        if (remainingElement) {
          remainingElement.textContent = `${remaining} ${productText}`;
        }
        
        console.log(`[D4F Header] ✅ ${currentCount} Produkte - Noch ${remaining} bis ${nextDiscount}`);
      }

    } catch (error) {
      console.error('[D4F Header] ❌ Error updating progress bar:', error);
    }
  }

  /**
   * KEYBOARD SHORTCUTS
   */
  function initKeyboardShortcuts() {
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        if (mobileMenu && mobileMenu.classList.contains('is-active')) {
          closeMobileMenu();
        }
        if (searchOverlay && searchOverlay.classList.contains('is-active')) {
          closeSearchOverlay();
        }
        if (recentModal && recentModal.classList.contains('is-active')) {
          closeRecentModal();
        }
      }

      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        if (searchOverlay && !searchOverlay.classList.contains('is-active')) {
          openSearchOverlay();
        }
      }
    });
  }

  /**
   * MEGA MENU ENHANCEMENTS
   */
  function initMegaMenuEnhancements() {
    const megaMenuItems = document.querySelectorAll('.d4f-mega-menu__item');
    
    megaMenuItems.forEach((item, index) => {
      item.style.setProperty('--item-index', index);

      item.addEventListener('click', () => {
        const title = item.querySelector('.d4f-mega-menu__title')?.textContent;
        trackEvent('mega_menu_click', title || 'unknown');
      });
    });
  }

  initMegaMenuEnhancements();

  /**
   * GIFT FINDER TRACKING
   */
  const giftFinderBtn = document.querySelector('.d4f-header__gift-finder');
  if (giftFinderBtn) {
    giftFinderBtn.addEventListener('click', () => {
      trackEvent('gift_finder_click', 'header');
    });
  }

  /**
   * ANALYTICS TRACKING
   */
  function trackEvent(action, label) {
    if (window.gtag) {
      window.gtag('event', action, {
        event_category: 'header',
        event_label: label
      });
    }

    if (window.fbq) {
      window.fbq('trackCustom', action, {
        location: 'header',
        label: label
      });
    }

    console.log('[D4F Header] Event:', action, label);
  }

  /**
   * SMOOTH SCROLL
   */
  function initSmoothScroll() {
    const anchorLinks = document.querySelectorAll('a[href^="#"]');
    
    anchorLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        const href = link.getAttribute('href');
        if (href === '#') return;

        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          const headerHeight = header.offsetHeight;
          const targetPosition = target.offsetTop - headerHeight - 20;

          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });

          if (mobileMenu && mobileMenu.classList.contains('is-active')) {
            closeMobileMenu();
          }
        }
      });
    });
  }

  initSmoothScroll();

  /**
   * WINDOW RESIZE
   */
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      if (window.innerWidth > 1024) {
        closeMobileMenu();
      }
    }, 250);
  });

  /**
   * LOGO TRACKING
   */
  const logo = document.querySelector('.d4f-header__logo a');
  if (logo) {
    logo.addEventListener('click', () => {
      trackEvent('logo_click', 'header');
    });
  }

  /**
   * MEGA MENU ACCESSIBILITY
   */
  function initMegaMenuA11y() {
    const menuItems = document.querySelectorAll('.d4f-header__menu-item--has-mega');

    menuItems.forEach(item => {
      const link = item.querySelector('.d4f-header__menu-link');
      const megaMenu = item.querySelector('.d4f-mega-menu');

      if (!link || !megaMenu) return;

      link.setAttribute('aria-haspopup', 'true');
      link.setAttribute('aria-expanded', 'false');

      link.addEventListener('click', (e) => {
        if (window.innerWidth <= 1024) {
          e.preventDefault();
          const isExpanded = link.getAttribute('aria-expanded') === 'true';
          link.setAttribute('aria-expanded', !isExpanded);
        }
      });

      link.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          link.click();
        }
      });
    });
  }

  initMegaMenuA11y();

  /**
   * CART EVENT LISTENERS
   */
  document.addEventListener('DOMContentLoaded', () => {
    console.log('[D4F Header] DOM loaded');
    
    setTimeout(() => {
      updateProgressBar();
    }, 500);
    
    document.addEventListener('cart:item-added', (e) => {
      console.log('[D4F Header] ⚡ Cart item added');
      updateCartCount();
      setTimeout(() => updateProgressBar(), 500);
      
      if (e.detail && e.detail.product) {
        trackEvent('add_to_cart', e.detail.product.title);
      }
    });

    document.addEventListener('cart:update', () => {
      console.log('[D4F Header] ⚡ Cart update');
      updateCartCount();
      updateProgressBar();
    });

    document.addEventListener('cart:refresh', () => {
      console.log('[D4F Header] ⚡ Cart refresh');
      updateCartCount();
      updateProgressBar();
    });

    if (cartCount) {
      const observer = new MutationObserver(() => {
        console.log('[D4F Header] 👀 Cart count changed (MutationObserver)');
        setTimeout(() => updateProgressBar(), 300);
      });

      observer.observe(cartCount, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }
  });

  /**
   * ANNOUNCEMENT BAR
   */
  function adjustHeaderPosition() {
    const announcementBar = document.querySelector('.announcement-bar');
    if (announcementBar) {
      const announcementHeight = announcementBar.offsetHeight;
      document.documentElement.style.setProperty('--announcement-height', `${announcementHeight}px`);
    }
  }

  adjustHeaderPosition();
  window.addEventListener('resize', adjustHeaderPosition);

  /**
   * PAGE LOAD
   */
  window.addEventListener('load', () => {
    header.classList.add('is-loaded');
    
    console.log('[D4F Header] 🚀 Page loaded - initial progress update');
    setTimeout(() => {
      updateProgressBar();
    }, 1000);
  });

  /**
   * BODY SCROLL PREVENTION
   */
  function preventBodyScroll() {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    
    const isSearchActive = searchOverlay?.classList.contains('is-active');
    const isMobileMenuActive = mobileMenu?.classList.contains('is-active');
    const isRecentActive = recentModal?.classList.contains('is-active');
    
    if (isSearchActive || isMobileMenuActive || isRecentActive) {
      document.body.style.paddingRight = `${scrollbarWidth}px`;
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.paddingRight = '';
      document.body.style.overflow = '';
    }
  }

  const bodyObserver = new MutationObserver(() => {
    preventBodyScroll();
  });

  if (mobileMenu) {
    bodyObserver.observe(mobileMenu, { attributes: true, attributeFilter: ['class'] });
  }
  if (searchOverlay) {
    bodyObserver.observe(searchOverlay, { attributes: true, attributeFilter: ['class'] });
  }
  if (recentModal) {
    bodyObserver.observe(recentModal, { attributes: true, attributeFilter: ['class'] });
  }

  console.log('[D4F Header] ✅ Initialized successfully');
})();